module.exports = __webpack_public_path__ + "src/img/add.d64421e9.svg";